<template>
  <transition name="fade">
    <div
      v-if="brand"
      class="absolute top-0 left-0 ma4 z-999"
      style="width: 6rem; height: 6rem;"
    >
      <router-link
        class="absolute absolute--fill"
        :to="{
          name: 'developments',
          params: { focusId: $route.params.id }
        }"
      >
        <div
          v-if="brand === 'lh'"
          class="w-100 h-100 tr relative br2 bg-white bg-center bg-no-repeat"
          :style="'background-size: 66%; background-image: url(' + logoPurple + ')'"
        />
        <img
          v-if="brand === 'lq'"
          src="@/assets/img/lq-logo.jpg"
          class="w-100 h-100 tr relative br2 bg-white"
        >
      </router-link>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Logo',
  data () {
    return {
      logoWhite: require('@/assets/img/lh-logo-white.svg'),
      logoPurple: require('@/assets/img/lh-logo-purple.svg')
    }
  },
  props: {
    brand: {
      type: String,
      default: 'lh'
    }
  }
}
</script>
